import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 25,
    color: 'black',
    margin: '0 auto 40px',
    display: 'block',
  },
  paper: {
    width: 500,
    marginTop: '80px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 40,
    boxShadow: 'none',
    '@media (min-height: 768px)': {
      marginTop: 'calc(50vh - 300px)',
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1, 0),
    width: '100%',
  },
  buttonBox: {
    marginTop: theme.spacing(4),
  },
  link: {
    width: '48%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#737373',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
  },
  margin: {
    margin: theme.spacing(1),
  },
  forgotPassword: {
    marginTop: theme.spacing(2),
  },
  button: {
    width: '48%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
    fontSize: '15px',
    fontWeight: 500,
  },
}));
